import Actions from '.';
import { get , deleteCall} from '../../../utils/api';
import { API_ERROR_MESSAGE } from '../../../constants';

const getUsers = () => (async (dispatch, getState) => {
    const { users: { userType } } = getState();
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`user/get-users?userType=${userType}`);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
                success: true,
                list: data.response || [],
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
                list: [],
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            list: [],
        }));
    }
});

const getUserDetails = id => (async dispatch => {
    dispatch(Actions.updateProperty('loadingData', true));
    try {
        const data = await get(`user/get-user/${id}`);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loadingData: false,
                error: '',
                data: data.response || {},
            }));
        } else {
            dispatch(Actions.updateProperties({
                loadingData: false,
                error: data.message || API_ERROR_MESSAGE,
                data: {},
                showDetails: false,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loadingData: false,
            error: e.message || API_ERROR_MESSAGE,
            data: {},
            showDetails: false,
        }));
    }
})

const deleteUsers = id => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await deleteCall(`user/${id}`);
        if (data.statusCode === 202) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
            }));
            dispatch(getUsers());
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
});

export default {
    getUsers,
    getUserDetails,
    deleteUsers
}